export function dealUserCount(data: {
  usageList: {
    totalCount: number
    useCount: number
  }[]
}) {
  if (data.usageList.length > 0) {
    const [totalCount, useCount] = data.usageList.reduce(
      (prev, usage) => [prev[0] + usage.totalCount, prev[1] + usage.useCount],
      [0, 0],
    )
    return totalCount - useCount
  }
}
